"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var scrollBtn = $('.scroll-btn');
    var scrollFunction = function () { return ($(window).scrollTop() > 20 ? scrollBtn.fadeIn() : scrollBtn.fadeOut()); };
    var scrolltoTop = function () { return $(window).scrollTop(0); };
    scrollFunction;
    $(window).on('scroll', scrollFunction);
    scrollBtn.on('click', scrolltoTop);
};
exports.init = init;
